/**
 * Created by yibrahim on 20/07/2017.
 */
import {TravelCredit} from './travel-credit';
import {BrokenRule} from './broken-rule';
import {AuditableResult} from './auditable-result';

export class AuditableTravelCredit extends AuditableResult<TravelCredit> {
  constructor(travelCredit: TravelCredit, brokenRules: Array<BrokenRule> = new Array<BrokenRule>()) {
    super(travelCredit, brokenRules);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/auditable-travel-credit.ts